module.exports = __webpack_public_path__ + "assets/img/33-l.aaba501.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/33-l.jpg
// module id = ez7F
// module chunks = 0